import React, {useState} from 'react';
import {Trans} from 'gatsby-plugin-react-i18next';
import {UseCases} from '../links/UseCases';
import {MenuItem, LinkWrapper, TriangleArrow, DropdownMenu} from '../utils/Styled';

export const UseCasesSelector: React.FC = () => {
  const [isOpen, setOpen] = useState(false);

  return (
    <MenuItem onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
      <LinkWrapper>
        <Trans>Businesses we Serve</Trans>
      </LinkWrapper>
      <DropdownMenu visible={isOpen} minWidth="500px" left="-200px" leftMobile="-160px" column>
        <TriangleArrow visible={isOpen} left="calc(55% - 8px)" />
        <UseCases itemClick={() => setOpen(false)} />
      </DropdownMenu>
    </MenuItem>
  );
};
